// apps/widget/src/screens/welcome.screen.tsx
//
// One screen, one job: get them to start. Everything explanatory belongs on the
// consent screen, which they have to read anyway.
//
// On a wide dialog this splits — pitch left, visual right. The visual is a
// rendering of what the product actually returns, drawn in the clinic's brand
// colour. A stock photograph of someone else's face would be the wrong promise
// to open with, and no clinic has uploaded one to use instead yet.

import { t } from '../lib/i18n';
import { useScan } from '../state';
import { SplitVisual } from '../components/split-visual';

export function WelcomeScreen() {
  const { state, go } = useScan();
  const { config } = state;

  // DORMANT tenants still open — the scan is off, but the lead form keeps the
  // widget earning its place on the clinic's page.
  const scanDisabled = config.mode === 'lead_only';

  return (
    <div className="gs-welcome">
      <div className="gs-welcome__copy gs-stack">
        {config.tenant.logoUrl && (
          <img src={config.tenant.logoUrl} alt={config.tenant.name} className="gs-logo" />
        )}

        <h1 className="gs-title gs-title--lg gs-welcome__title">
          {config.copy.headline ?? t('welcome.title')}
        </h1>

        <p className="gs-body gs-welcome__lede">
          {/* A clinic's own wording is in one language, so it replaces the
              scan pitch only — the lead-only explanation stays translated. */}
          {scanDisabled
            ? t('lead.subtitle')
            : (config.copy.subtitle ?? t('welcome.subtitle', { clinic: config.tenant.name }))}
        </p>

        <button
          className="gs-btn gs-btn--primary"
          onClick={() => go(scanDisabled ? 'lead' : 'consent')}
        >
          {scanDisabled ? config.copy.ctaLabel : (config.copy.startLabel ?? t('welcome.start'))}
        </button>

        {!scanDisabled && <p className="gs-muted">{t('welcome.duration')}</p>}
      </div>

      <SplitVisual config={config} />
    </div>
  );
}

/**
 * Decorative, and marked aria-hidden by the parent: the numbers are an example
 * of the output, not this visitor's result, and a screen reader announcing them
 * as if they were real would be misleading.
 */
